export default "__VITE_ASSET__DaIyFTZ8__"